<template>
  <div>
    <app-header />
    <slot></slot>
  </div>
</template>
<script>
import Header from '../components/plan/Header'
export default {
  name: 'plan',
  components: {
    appHeader: Header
  },
  mounted () {
    $('body').addClass('bg-white').addClass('cscroll')
  },
  beforeCreate () {
    if (localStorage.locale) this.$i18n.locale = localStorage.locale
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/plan.vue